export default __webpack_public_path__ + "../staticImages/advent-lightbox-top-quiz-2x.png";